module.exports = __webpack_public_path__ + "img/Avatar-89.999e599c.svg";